import { NotificationHelper } from "../../core/util/notificationHelper";
import { AppHelper } from "../../appHelper";
import { AppBaseProps, CommonApp, Entity } from "../../core/components/commonApp";
import { MetaDataHelper } from "../../core/util/metaDataHelper";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { General } from "../../../siteManagement/general";
import { DialogHelper } from "../../core/util/dialogHelper";
import { Config } from "../../core/config/config";
import { SheetEventType } from "../../../siteManagement/sheet";
import { Helper } from "../../core/util/helper";
import { PageTitleProps } from "../../core/components/pageTitle";
import { KeyValuePair, StringKeyDictionary } from "../../commonInterfaces";
import React from "react";
export default class ServiceHoursApp extends React.Component<ServiceHoursProps, any> {
    common = new AppHelper();
    //schaltet den Browsertab-Titel an; wird von common aufgerufen
    setTabTitle = true;
    deleteEnabled = false;
    isDeleted = false;
    translations: StringKeyDictionary<string> = null;
    computedPageTitle: string = "";

    private updateTypeOfStr(pos: ServiceHoursPosEntity, typesOfDay: KeyValuePair<number, string>[]) {
        let typeOfDay: string;
        var tod = Helper.getArrayItem(typesOfDay, "Key", pos.TypeOfDay);
        if (tod != null)
            typeOfDay = tod.Value;
        else
            typeOfDay = "unknown value " + pos.TypeOfDay;
        pos.TypeOfDayStr = typeOfDay;
    }

    constructor(props) {
        super(props);
        this.common.init(this);
        this.props.context.translations = this.translations;
        if (Helper.hasValue(this.props.entity.EntityUsage)) {
            this.computedPageTitle = Helper.getTranslation("WebSMS.SLA.ServiceHour.PageTitle.Copy").replace('{serviceHour}', this.props.entity.Title).replace('{agreement}', this.props.entity.UsageTitle);
        } else {
            this.computedPageTitle = this.translations["WebSMS.SLA.ServiceHour.PageTitle.Global"] + (this.props.entity.IsNew ? "" : " - " + this.props.entity.Title);
        }
        this._refreshDeleteEnabled();
    }

    private _refreshDeleteEnabled() {
        this.deleteEnabled = !this.props.entity.IsNew && this.props.entity.RecordRight.CanWrite
    }

    internalValidate = () => {
        if (this.props.entity.Active) {
            if (this.props.entity.Positions.length <= 0) {
                DialogHelper.alert(this.translations["WebSMS.SLA.ServiceHoursDeclar"]);
                return false;
            }

            // check for intersects
            if (this.props.entity.Positions.length > 1) {
                let i: number;
                let j: number;
                for (i = 0; i < (this.props.entity.Positions.length-1); ++i) {
                    let pos = this.props.entity.Positions[i];
                    for (j = i + 1; j < this.props.entity.Positions.length; ++j) {
                        let refPos = this.props.entity.Positions[j];
                        if (pos.TypeOfDay == refPos.TypeOfDay &&
                            (pos.EndMinute > refPos.StartMinute) &&
                            (pos.StartMinute < refPos.EndMinute)) {
                            DialogHelper.alert(this.translations["WebSMS.SLA.ServiceHoursOverlap"]);
                            return false;
                        }
                    }
                }
            }
        }
        return true;
    }

    save = (closeAfterSave) => {
        if (this.internalValidate()) {
            if (this.common.validate()) {
                HTTPService.post<JsonResultClass>("SlaServiceHours/Save", this.props.entity)
                    .then(result => {
                            //            let returnNull = true;
                            if (result.Code === 0) {
                                if (this.props.entity.IsNew) {
                                    this.props.entity.IsNew = false;
                                    this.props.entity.Id = result.Id;
                                    General.Functions.HistoryState.replaceState("SlaServiceHours/Edit?id=" +
                                        encodeURIComponent(this.props.entity.Id));
                                }
                                for (var p of this.props.entity.Positions) {
                                    if (p.IsNew) {
                                        p.IsNew = false;
                                    }
                                }
                                this._refreshDeleteEnabled();
                                NotificationHelper.showSuccessMessage(result.Message);
                                //NotificationHelper.showInfoMessage("Saved!");
                            } else {
                                NotificationHelper.showErrorMessage(result.Message);
                            }

                            this.common.handlePostSave(result.Code === 0, closeAfterSave);
                        },
                        () => {

                        });
            } else {
                //NotificationHelper.showErrorMessage("Unable to save. Correct errors and try again.");
            }
        }
    }

    remove = () => {
        DialogHelper.confirm(this.translations["Standard.Msg.Loeschen"]).then(isOk => {
            if (isOk) {
                HTTPService.post<JsonResultClass>('SlaServiceHours/Delete?id=' + this.props.entity.Id)
                    .then(result => {
                        if (result.Code === 0) {
                            NotificationHelper.showSuccessMessage(result.Message);
                            this.common.sheetWrapper.trigger(SheetEventType.ItemDeleted, this.props.entity);
                            if (this.common.isWindow) {
                                this.common.sheetWrapper.hide();
                            } else {
                                this.deleteEnabled = false;
                                this.isDeleted = true;
                                this.props.entity.RecordRight.CanWrite = false;
                                this.setState({});
                                setTimeout(() => {
                                    window.location.href = Config.baseUrl + "DynamicSearch/SlaServiceHours";
                                }, 1000);
                            }
                        } else {
                            NotificationHelper.showErrorMessage(result.Message);
                        }
                    });
            }
        });
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        switch (field.model) {
            case "entity.Calendar.Id":
                this.props.entity.Calendar = {
                    Id: value,
                    Name: dataItem.Name
                };
                break;
        }

        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }



    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        const titleProps: PageTitleProps = {
            title: this.props.title,
            value: this.props.entity.Title
        };

        props.context.TypesOfDay = this.props.TypesOfDay;
        return <CommonApp {...props} titleProps={titleProps} />;
    }


    importFromAdress = () =>  {

        const dynamicSearchUrl = Config.baseUrl + "DynamicSearch/Window/Address?multi=false&displayPattern=[[adrnr]]";

        const sheet = General.Sheet.Manager.createSheetWithUrl(dynamicSearchUrl, null, { disableTabTitle: true });
        sheet.setTitle(Config.translations.addressSearch);
        sheet.bind(SheetEventType.RowClicked, (e) => {
            
            const haursUrl = "AddressOpeningHours/GetOpeningHours?id=" + encodeURIComponent(e);

            HTTPService.get(haursUrl)
                .then((res) => {
                    for (const item of res.Data) {
                        let item_new: ServiceHoursPosEntity = Helper.createEmptyEntity() as ServiceHoursPosEntity;
                        item_new.Id = kendo.guid();

                        //Convert DayOfWek (1 = Sonntag ..7 = Samstag) to TypeOfDay (0 = Mo .. 6 = So)      
                        if (item.DayOfWeek >= 2)
                            item_new.TypeOfDay = item.DayOfWeek - 2
                        else
                            item_new.TypeOfDay = 6;
                       
                        this.updateTypeOfStr(item_new, this.props.TypesOfDay);
                        item_new.StartMinute = item.StartTime;
                        item_new.StartStr = item.StartTimeStr;
                        item_new.EndMinute = item.EndTime;
                        item_new.EndStr = item.EndTimeStr;

                        this.props.entity.Positions.push(item_new);
                        
                    }
                    this.props.entity.Positions.sort((a, b) => { return a.TypeOfDay == b.TypeOfDay ? a.StartMinute - b.StartMinute : a.TypeOfDay - b.TypeOfDay });
                    this.setState({});
                });
        });
     }
};

export interface ServiceHoursPosEntity extends Entity {
    Id: string;
    TypeOfDay: number;
    TypeOfDayStr: string;
    StartMinute: number;
    StartStr: string;
    EndMinute: number;
    EndStr: string;
}

export interface ServiceHoursEntity extends Entity {
    Id: string;
    Title: string;
    Active: boolean;
    EntityUsage: any;
    UsageTitle: string;
    Calendar: {
        Id: number,
        Name: string
    }
    Positions: ServiceHoursPosEntity[];
}

export interface ServiceHoursProps extends AppBaseProps {
    entity: ServiceHoursEntity;
    context: any;
    TypesOfDay: KeyValuePair<number, string>[];
}